import React, { useRef } from "react";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut, getElementAtEvent } from "react-chartjs-2";
import { useResizeObserver } from "src/hooks";
// import { useMediaQuery } from "usehooks-ts";

const SurveyChart = ({ areas = [], finalPercentage, totalPossible,isFinal }) => {
  ChartJS.register(ArcElement, Tooltip, Legend);
  ChartJS.register(ChartDataLabels);

  const colors = ["#009245", "#FFDF07", "#A421D1", "#487db2", "gainsboro"];

  const { width } = useResizeObserver();
  const isMobile = width < 1000;


  const remainingPoints =
    totalPossible - areas.reduce((acc, curr) => acc + curr.score, 0);

  const chartRef = useRef(null);

  const data = {
    labels: [...areas.map((entry) => entry.label)],
    datasets: [
      {
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.label;
              let value = context.formattedValue;

              if (!label) label = "Remaining";
              return `${label}: ${value}pt`;
            },
          },
        },
        data: [...areas.map((entry) => entry.score), remainingPoints],
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const clickHandler = (e) => {
    const index = getElementAtEvent(chartRef.current, e)?.[0]?.index;
    if (index === undefined) return;

    document
      .querySelector(`.section-${index}`)
      ?.scrollIntoView({ behavior: "smooth" });
  };

  const CHART_OPTIONS = {
    cutout: isMobile ? "40%" : "60%",
    plugins: {
      bgColor: {
        backgroundColor: "transparent",
      },
      datalabels: {
        formatter: (value, context) => {
          // const percentage = areas?.[context.dataIndex]?.percentage || "0";
          return !!value && value > 0 ? `${value} pt` : "";
        },
        align: "center",
        font: { size: isMobile ? 12 : 14 },
        backgroundColor: function (context) {
          const index = context.dataIndex;
          const value = context.dataset.data[index];

          return value > 0 ? `rgba(0,0,0,0.3)` : "transparent";
        },
        borderRadius: "5",
        color: "#ffffff",
        textAlign: "center",
      },
      legend: {
        position: "bottom",
        title: {
          padding: isMobile ? 0 : 5,
          display: true,
        },
        labels: {
          padding: isMobile ? undefined : 20,
          font: {
            size: isMobile ? 14 : 18,
          },
        },
      },
    },
  };

  const mobileTitleStyle = {
    position: "static",
    fontSize: "2rem",
    fontWeight: "bold",
  };

  const desktopTitleStyle = {
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: "2rem",
    fontWeight: "bold",
  };

  const finalPercentageToDisplay = isNaN(finalPercentage) ? 0 : finalPercentage;

  if (isNaN(+finalPercentage)) return null;


  return (
    <div
      style={{
        maxWidth: "700px",
        marginInline: "auto",
      }}
      className="position-relative"
    >
      <div style={isMobile ? mobileTitleStyle : desktopTitleStyle}>
        <h3 className="mb-1 circle-text">{isFinal?"FINAL SCORE":"SCORE"}</h3>
        <h1
          style={{
            fontSize: "5rem",
            textAlign: "center",
          }}
        >
          {finalPercentageToDisplay}%
        </h1>
      </div>

      <Doughnut
        id="esg-chart"
        data={data}
        options={CHART_OPTIONS}
        ref={chartRef}
        onClick={clickHandler}
      />
    </div>
  );
};

export default SurveyChart;
